module.exports = __webpack_public_path__ + "img/pause-icon.fd7628a7.svg";